import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import { Button, Label, Image, Divider, Popup } from 'semantic-ui-react'

const Row = styled.div`
  display: flex;
  align-items: center;
  border-radius: 7px;
  height: 100px;
  margin-bottom: 15px;
`

const ImageWrapper = styled.div`
  width: 80px;
  height: 80px;
  margin-left: 20px;
  margin-right: 20px;
`

const MerchantNameWrapper = styled.div`
  width: 30%;
  margin-Right: 20px;
`

const MerchantName = styled.h4`
  margin-bottom: 0;
`

const CostSharingWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
`

const QuantityWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  width: 250px;
`

const ActionButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-right: 20px;
`

const Placeholder = styled.div`
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const UserLimitation = styled.div`
  margin-top: 5px;
`

const CostSharing = ({ data }) => (
  <CostSharingWrapper>
    {data && (
      <Popup
        trigger={
          <Label color="green" size="medium">
            Cost Sharing
                </Label>
        }
      >
        <div>{`Merchant : ${data.merchant}%`}</div>
        <div>{`Company : ${data.company}%`}</div>
      </Popup>
    )}
  </CostSharingWrapper>
)

const DealItem = ({ item, onEdit, onDelete, onSoldItemEdit, restaurants }) => {
  const restaurant = restaurants[item.merchant_id]
  const restaurantName = get(restaurant, 'name', 'N/A')

  const {
    name,
    sold,
    price,
    images,
    unlimit,
    quantity,
    cost_sharing: costSharing,
    discount_rate: discountRate,
    limit_per_user: limitPerUser,
  } = item

  return (
    <React.Fragment>
      <Row>
        <ImageWrapper>
          {images ? (
            <Image
              src={images.image}
              size="tiny"
              rounded
              verticalAlign="middle"
              style={{ width: 80, height: 80 }}
            />
          ): (
            <Placeholder>No Image</Placeholder>
          )}
        </ImageWrapper>

        <MerchantNameWrapper>
          <MerchantName>{name}</MerchantName>
          <div>Merchant: {restaurantName}</div>
          <div>Price: {`${price.toFixed(2)}$`}</div>
        </MerchantNameWrapper>

        <QuantityWrapper>
          <Label color="orange" tag>{`${discountRate}%`}</Label>
          <Label
            onClick={unlimit ? null : onSoldItemEdit}
            style={{ textAlign: 'center', cursor: unlimit ? 'default' : 'pointer' }}
          >
            {unlimit ? 'Unlimited' : `Quantity: ${sold}/${quantity}`}
            {limitPerUser > 0 && <UserLimitation>{`(${limitPerUser} per user)`}</UserLimitation>}
          </Label>
        </QuantityWrapper>

        <CostSharing data={costSharing} />

        <ActionButtonWrapper>
          <Button color="black" content="Edit" size="tiny" onClick={onEdit} />
          <Button color="red" content="Delete" size="tiny" onClick={onDelete} />
        </ActionButtonWrapper>
      </Row>
      <Divider />
    </React.Fragment>
  )
}

export default DealItem



// WEBPACK FOOTER //
// ./src/components/specialDeal/dealItem.js